module.exports = __webpack_public_path__ + "img/Fleurs_et_pompons.b9706cc.jpg";